export default {"src":"/_next/static/media/solana-white.22cbef0c.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};